(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.CMSizeGuideData = api;
})(typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  const NUMBER = '(?:\\d+(?:\\.\\d+)?|\\.\\d+)';
  const numeric = new RegExp('^' + NUMBER + '$');
  const range = new RegExp('^(' + NUMBER + ')(\\s*[-–—]\\s*)(' + NUMBER + ')$');
  const cmUnit = /\b(?:cm|centimetres?|centimeters?)\b/i;

  function clean(value) {
    return value.replace(/\*\*|__/g, '').trim();
  }

  function cells(line, kind) {
    if (kind === 'tsv') return line.split('\t').map(clean);
    const trimmed = line.trim();
    const parts = trimmed.split('|');
    if (trimmed.startsWith('|')) parts.shift();
    if (trimmed.endsWith('|')) parts.pop();
    return parts.map(clean);
  }

  function notesFrom(lines) {
    const notes = [];
    const seen = new Set();
    lines.forEach(function (line) {
      const note = clean(line.replace(/^\s{0,3}#{1,6}\s+/, '').replace(/^\s*(?:[-*+]\s+|\d+[.)]\s+)/, ''));
      if (!note || /(?:^|[—–-]\s*)(?:size\s*guide|guide des tailles|größentabelle|guida alle taglie)\s*[:.!]?$/i.test(note)) return;
      if (/^all measurements are garment measurements in centim(?:etres|eters)\s*\(cm\)\.?$/i.test(note)) return;
      if (/\(cm\)/i.test(note) && /^(?:toutes les mesures|alle angaben|tutte le misure)/i.test(note)) return;
      if (!seen.has(note)) { seen.add(note); notes.push(note); }
    });
    return notes;
  }

  function parse(source) {
    if (typeof source !== 'string' || !cmUnit.test(source)) return null;
    const lines = source.replace(/^\uFEFF/, '').replace(/\r\n?/g, '\n').split('\n');
    let start = -1;
    let kind;
    let headers;
    for (let index = 0; index < lines.length; index++) {
      const format = lines[index].includes('\t') ? 'tsv' : lines[index].includes('|') ? 'markdown' : null;
      if (!format) continue;
      const candidate = cells(lines[index], format);
      if (candidate.length > 1 && /^(?:size|taille|größe|taglia)$/i.test(candidate[0])) {
        if (candidate.some(function (cell) { return !cell; })) return null;
        start = index;
        kind = format;
        headers = candidate;
        break;
      }
    }
    if (start < 0) return null;

    const rows = [];
    const notes = lines.slice(0, start);
    let ended = false;
    for (let index = start + 1; index < lines.length; index++) {
      const line = lines[index];
      if (!line.trim()) continue;
      const delimited = kind === 'tsv' ? line.includes('\t') : line.includes('|');
      if (delimited) {
        if (ended) return null;
        const row = cells(line, kind);
        if (row.length !== headers.length || row.some(function (cell) { return !cell; })) return null;
        if (kind === 'markdown' && row.every(function (cell) { return /^:?-{3,}:?$/.test(cell); })) {
          if (rows.length) return null;
          continue;
        }
        rows.push(row);
      } else {
        // Do not silently turn a malformed size row into a footnote.
        if (/^(?:XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|\d+)\s+(?:\d|[–—-])/i.test(line.trim())) return null;
        ended = true;
        notes.push(line);
      }
    }
    return rows.length ? { headers: headers, rows: rows, notes: notesFrom(notes) } : null;
  }

  function format(value, unit) {
    const original = value == null ? '' : String(value);
    if (unit !== 'in') return original;
    const text = original.trim();
    const convert = function (number) {
      const value = Number(number);
      return Number.isFinite(value) ? (value / 2.54).toFixed(1) : null;
    };
    if (numeric.test(text)) return convert(text) || original;
    const match = text.match(range);
    if (!match || Number(match[1]) > Number(match[3])) return original;
    const first = convert(match[1]);
    const last = convert(match[3]);
    return first !== null && last !== null ? first + match[2] + last : original;
  }

  return Object.freeze({ parse: parse, format: format });
});
